import { Component, OnInit, TemplateRef, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material';
import { environment } from 'src/environments/environment';
import * as $ from 'jquery';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

  res: any = "";
  submitted1 = false;
  mobilno: any;
  contenthide = true;
  successcontenthide = true;

  feedRes: any;
  message: any;

  captchaRes: any;
  isDisabledCap = true;
  isDisabledTick = false;
  capOption: any;
  state = {
    token: null,
    stats: [],
    icons: [],
    visible: false,
    checked: false,
    captchaInput: null,
    result: false,
    failedcaptcha: false,
    validated: null,
    attempts: 40,
    numbers: [],
    number1: null,
    number2: null,
    number3: null,
    number4: null
  }

  // des : any;

  FBComType = new FormGroup({
    ComType: new FormControl(),
  })

  FBJioID = new FormGroup({
    jioId: new FormControl(),
  })

  FBFname = new FormGroup({
    Fname: new FormControl(),
  })

  // FBemail = new FormGroup({
  //   email: new FormControl(),
  // })

  FBdevicemake = new FormGroup({
    devicemake: new FormControl(),
  })

  FBdevicemodel = new FormGroup({
    devicemodel: new FormControl(),
  })

  FBosver = new FormGroup({
    osver: new FormControl(),
  })

  FBssh = new FormGroup({
    ssh: new FormControl(),
  })

  FBdesc = new FormGroup({
    desc: new FormControl(),
  })

  // recaptcha = new FormGroup({
  //   recaptchaReactive: new FormControl(),
  // })

  isDisabled = true;

  loading = false;
  submittedComType = false;
  submittedid = false;
  submittedname = false;
  submittedemail = false;
  submitteddevicemake = false;
  submitteddevice = false;
  submittedos = false;
  submitteddesc = false;
  // submittedRecaptcha = false;

  flag1 = 0;
  flag2 = 0;
  flag3 = 0;
  flag4 = 0;
  flag5 = 0;
  flag6 = 0;
  flag7 = 0;
  flag8 = 0;
  flag9 = 0;
  iphonecontenthide = true;
  actualFile: any;
  screenW = false;
  checked = false;
  message2: any;
  countryCode: any;
  concatNum: any;

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private router: Router, private route: ActivatedRoute,
    private dialog: MatDialog
    , public dialog_1: MatDialogRef<TemplateRef<any>>, public dialog_2: MatDialogRef<TemplateRef<any>>,
    public dialog_3: MatDialogRef<TemplateRef<any>>, public dialog_4: MatDialogRef<TemplateRef<any>>,
    public dialog_5: MatDialogRef<TemplateRef<any>>, private _sanitizer: DomSanitizer) { }

  showModal(content) {
    this.contenthide = false;
    this.dialog_1 = this.dialog.open(content, {
      panelClass: 'custom-dialog-container',
      autoFocus: false,
      restoreFocus: true,
      role: 'dialog',
      disableClose: true,

      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';

    })


  }
  modal1 = new FormGroup({
    jioId: new FormControl()
  });

  getlink(successcontent, failurecontent, content) {
    this.submitted1 = true;
    if (this.modal1.invalid) {
      document.getElementById("errormessage").style.display = "block";
    }
    else {

      document.getElementById("errormessage").style.display = "none";
      let data = { "phoneno": this.modal1.value.jioId }
      this.mobilno = this.modal1.value.jioId;
      this.http.post(environment.validate, data).subscribe(
        data => {
          // //console.log(data);

          this.res = data;
          if (this.res.status == "OK") {

            this.contenthide = true;
            this.successcontenthide = false;
            this.dialog_2 = this.dialog.open(successcontent, {
              panelClass: 'success-dialog-container',
              restoreFocus: true,
              role: 'dialog',
              autoFocus: false,
              disableClose: true,
              // height:'200px'
              // padding-left: '17%';
              // padding-right: '17%';

            })


          }
          else {
            // this.dialog.closeAll()
            // this.dialog_1.close();
            // this.dialog_1.afterClosed().subscribe(result => {
            //   //console.log("closed dialog");

            // });
            this.contenthide = true;

            this.dialog_3 = this.dialog.open(failurecontent, {
              panelClass: 'failure-dialog-container',

              // backdropClass: 'failurebackdrop'
              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,

              // }


            })
          }

          ;
        })
    }
  }
  scroll() {
    document.querySelector('#top').scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  dismissmodal() {
    this.dialog.closeAll()
    this.modal1.reset();

    //captcha
    this.isDisabledTick = false;
    this.checked = false;
    this.isDisabledCap = true;
    // this.capOption = null;
    // // this.initialCaptcha();
    // this.captchaRes = {
    //   "image": null,
    //   "options": [null, null, null, null]
    // }
    this.flag9 = 0;  //captcha flag
  }
  get f() { return this.modal1.controls; }

  openapk() {

    this.dismissmodal();
    // window.open('./assets/apk/JioID-1.0.4.apk');
    window.open(environment.androidlink);



  }

  openipapk() {
    this.dismissmodal();
    window.open(environment.iOSlink);
  }




  ngOnInit() {

    console.log(window.screen.width);
    if (window.screen.width >= 1100) {  //class=aside visibility for desktop
      this.screenW = true;
    }
    else {
      this.screenW = false;
    }

    // this.initialCaptcha();
    this.loading = false;
    this.checked = false;
    this.isDisabledCap = true;
    this.isDisabledTick = false;
    this.captchaRes = {
      "image": null,
      "options": [null, null, null, null]
    }

    this.isDisabled = true;
    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";
    this.message = null;
    this.FBJioID.reset();
    this.FBFname.reset();
    // this.FBemail.reset();
    this.FBdevicemake.reset();
    this.FBdevicemodel.reset();
    this.FBosver.reset();
    this.FBdesc.reset();
    this.FBComType.reset();
    this.FBssh.reset();
    // this.recaptcha.reset();

    this.flag1 = 0;
    this.flag2 = 0;
    // this.flag3 = 0;
    this.flag4 = 0;
    this.flag5 = 0;
    this.flag6 = 0;
    this.flag7 = 0;
    this.flag8 = 0;
    this.flag9 = 0;

    document.getElementById("comtype").style.display = "none";
    document.getElementById("jid").style.display = "none";
    document.getElementById("jname").style.display = "none";
    // document.getElementById("jemail").style.display = "none";
    document.getElementById("jdevicemake").style.display = "none";
    document.getElementById("jdevice").style.display = "none";
    document.getElementById("jos").style.display = "none";
    document.getElementById("jdesc").style.display = "none";
    document.getElementById("jssh").style.display = "none";

    // document.getElementById("errorM").style.display = "none";

    this.FBComType = this.formBuilder.group({
      ComType: ['', [Validators.required]]
    });
    this.FBJioID = this.formBuilder.group({
      // jioId: ['', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$')]]  //valid Indian mobile no. starting from 6,7,8,or 9.
      jioId: ['', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(4), Validators.maxLength(15)]]  //valid International mobile number.

    });
    this.FBFname = this.formBuilder.group({
      Fname: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100),
      Validators.pattern('^[a-zA-Z ]*$')]]
    })
    // this.FBemail = this.formBuilder.group({
    //   email: ['', [Validators.required, Validators.pattern('^([a-zA-Z0-9_.-]+)@([a-zA-Z0-9_.-]+)\\.([a-zA-Z]{2,9})$')]]
    // })  , Validators.pattern('^[ A-Za-z0-9]*$')  for alphanumeric
    this.FBdevicemake = this.formBuilder.group({
      devicemake: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]]
    })
    this.FBdevicemodel = this.formBuilder.group({
      devicemodel: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]]
    })
    this.FBosver = this.formBuilder.group({
      osver: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]]
    })
    this.FBdesc = this.formBuilder.group({
      desc: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(2000), 
         Validators.pattern('^[A-Za-z0-9_]*$|^[A-Za-z0-9_][A-Za-z0-9_ ]*[A-Za-z0-9_]$')]]  //regex for no spaces before or after description
    })

    // this.recaptcha = this.formBuilder.group({
    //   recaptchaReactive: ['', [Validators.required]]
    // })


    this.route.fragment.subscribe(f => {
      const element = document.querySelector("#" + f)
      if (element) element.scrollIntoView()
    })


    this.modal1 = this.formBuilder.group({

      jioId: ['', [Validators.required, Validators.pattern('^^[0-9]{10}$')]]
    })

  }

  loginPage() {
    // //console.log("redirect to login page");
    // window.location.reload();

    this.router.navigateByUrl("/login")
  }

  first() {


    document.getElementById("buttonD1").style.display = "block";

    // //console.log((this.loginJioID.invalid));

    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";

    this.isDisabled = true;



    if (this.flag1 == 1 && this.flag2 == 1 && this.flag4 == 1 && this.flag5 == 1 &&
      this.flag6 == 1 && this.flag7 == 1 && this.flag8 == 1 && this.flag9 == 1) {
      // document.getElementById("error1").style.display = "none";

      document.getElementById("buttonD1").style.backgroundColor = "#224797";
      document.getElementById("buttonD1").style.borderColor = "#224797";
      document.getElementById("buttonD1").style.color = "white";

      this.isDisabled = false;
    }

    else {
      document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
      document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
      document.getElementById("buttonD1").style.color = "#707070";

      // document.getElementById("error1").style.display = "block";

      this.isDisabled = true;
    }

  }

  get f1() { return this.FBJioID.controls; }
  get f2() { return this.FBFname.controls; }
  // get f3() { return this.FBemail.controls; }
  get f4() { return this.FBdevicemodel.controls; }
  get f5() { return this.FBosver.controls; }
  get f6() { return this.FBdesc.controls; }
  get f7() { return this.FBComType.controls; }
  get f8() { return this.FBdevicemake.controls; }
  // get f9() { return this.recaptcha.controls; }


  inputComType() {
    //console.log("inputComType()");
    // console.log(this.FBComType.value.ComType);

    this.submittedComType = true;

    this.isDisabledTick = false;
    this.checked = false;
    this.capOption = null;
    // this.initialCaptcha();
    this.captchaRes = {
      "image": null,
      "options": [null, null, null, null]
    }
    this.flag9 = 0;  //captcha flag

    this.isDisabled = true;
    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";

    if (this.FBComType.invalid) {
      this.flag7 = 0;
      document.getElementById("comtype").style.display = "none";

      this.isDisabled = true;
      document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
      document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
      document.getElementById("buttonD1").style.color = "#707070";
      return;
    }
    else {
      this.flag7 = 1;
      document.getElementById("comtype").style.display = "block";
    }
    this.first();
  }
  inputJioID() {
    //console.log("inputJioID()");
    this.submittedid = true;
    this.isDisabledTick = false;
    this.checked = false;
    this.capOption = null;
    // this.initialCaptcha();
    this.captchaRes = {
      "image": null,
      "options": [null, null, null, null]
    }
    this.flag9 = 0;  //captcha flag

    this.isDisabled = true;
    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";

    if (this.FBJioID.invalid) {
      this.flag1 = 0;
      document.getElementById("jid").style.display = "none";

      this.isDisabled = true;

      document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
      document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
      document.getElementById("buttonD1").style.color = "#707070";
      return;
    }
    else {
      this.flag1 = 1;
      document.getElementById("jid").style.display = "block";
    }
    this.first();
  }

  inputFname() {
    //console.log("inputFname()");
    this.submittedname = true;
    this.isDisabledTick = false;
    this.checked = false;
    this.capOption = null;
    // this.initialCaptcha();
    this.captchaRes = {
      "image": null,
      "options": [null, null, null, null]
    }
    this.flag9 = 0;  //captcha flag

    this.isDisabled = true;
    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";

    if (this.FBFname.invalid) {
      this.flag2 = 0;
      document.getElementById("jname").style.display = "none";

      this.isDisabled = true;

      document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
      document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
      document.getElementById("buttonD1").style.color = "#707070";
      return;
    }
    else {
      this.flag2 = 1;
      document.getElementById("jname").style.display = "block";
    }
    this.first();
  }

  // inputemail() {
  //   //console.log("inputemail()");
  //   this.submittedemail = true;

  //   if (this.FBemail.invalid) {
  //     this.flag3 = 0;
  //     document.getElementById("jemail").style.display = "none";

  //     this.isDisabled = true;
  //     
  // document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
  // document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
  // document.getElementById("buttonD1").style.color = "#707070";
  //     return;
  //   }
  //   else {
  //     this.flag3 = 1;
  //     document.getElementById("jemail").style.display = "block";

  //     this.first();
  //   }
  // }

  inputDevicemake() {
    //console.log("inputDevice()");
    this.submitteddevicemake = true;
    this.isDisabledTick = false;
    this.checked = false;
    this.capOption = null;
    // this.initialCaptcha();
    this.captchaRes = {
      "image": null,
      "options": [null, null, null, null]
    }
    this.flag9 = 0;  //captcha flag

    this.isDisabled = true;
    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";

    if (this.FBdevicemake.invalid) {
      this.flag8 = 0;
      document.getElementById("jdevicemake").style.display = "none";

      this.isDisabled = true;

      document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
      document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
      document.getElementById("buttonD1").style.color = "#707070";
      return;
    }
    else {
      this.flag8 = 1;
      document.getElementById("jdevicemake").style.display = "block";
    }
    this.first();
  }

  inputDevice() {
    //console.log("inputDevice()");
    this.submitteddevice = true;
    this.isDisabledTick = false;
    this.checked = false;
    this.capOption = null;
    // this.initialCaptcha();
    this.captchaRes = {
      "image": null,
      "options": [null, null, null, null]
    }
    this.flag9 = 0;  //captcha flag

    this.isDisabled = true;
    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";

    if (this.FBdevicemodel.invalid) {
      this.flag4 = 0;
      document.getElementById("jdevice").style.display = "none";

      this.isDisabled = true;
      // document.getElementById("buttonD1").style.backgroundColor = "#aa9f9fbd";
      // document.getElementById("buttonD1").style.borderColor = "#aa9f9fbd";
      document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
      document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
      document.getElementById("buttonD1").style.color = "#707070";
      return;
    }
    else {
      this.flag4 = 1;
      document.getElementById("jdevice").style.display = "block";
    }
    this.first();
  }

  inputOS() {
    //console.log("inputOS()");
    this.submittedos = true;
    this.isDisabledTick = false;
    this.checked = false;
    this.capOption = null;
    // this.initialCaptcha();
    this.captchaRes = {
      "image": null,
      "options": [null, null, null, null]
    }
    this.flag9 = 0;  //captcha flag

    this.isDisabled = true;
    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";

    if (this.FBosver.invalid) {
      this.flag5 = 0;
      document.getElementById("jos").style.display = "none";

      this.isDisabled = true;
      document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
      document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
      document.getElementById("buttonD1").style.color = "#707070";
      return;
    }
    else {
      this.flag5 = 1;
      document.getElementById("jos").style.display = "block";
    }
    this.first();
  }

  inputssh(e) {
    // console.log(this.FBssh.value.ssh);
    this.isDisabledTick = false;
    this.checked = false;
    this.capOption = null;
    // this.initialCaptcha();
    this.captchaRes = {
      "image": null,
      "options": [null, null, null, null]
    }
    this.flag9 = 0;  //captcha flag

    this.isDisabled = true;
    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";

    if (this.FBssh.value.ssh) {
      document.getElementById("jssh").style.display = "block";
      var file = e.target.files[0];
      // console.log(file);

      this.actualFile = file;  //use this file to send in body of api
      // console.log(this.actualFile);
    }
    else {
      this.actualFile = null;
      // console.log(this.actualFile);

      document.getElementById("jssh").style.display = "none";
    }
  }

  inputDesc() {
    //console.log("inputDesc()");
    this.submitteddesc = true;
    this.isDisabledTick = false;
    this.checked = false;
    this.capOption = null;
    // this.initialCaptcha();
    this.captchaRes = {
      "image": null,
      "options": [null, null, null, null]
    }
    this.flag9 = 0;  //captcha flag

    this.isDisabled = true;
    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";

    // this.des = this._sanitizer.sanitize(SecurityContext.HTML, this.FBdesc.value.desc);
    if (this.FBdesc.invalid) {
      this.flag6 = 0;
      document.getElementById("jdesc").style.display = "none";

      this.isDisabled = true;
      document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
      document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
      document.getElementById("buttonD1").style.color = "#707070";
      return;
    }
    else {
      this.flag6 = 1;
      document.getElementById("jdesc").style.display = "block";
    }
    this.first();
  }

  // recaptchaFunct(captchaResponse: string) {   //for Google recaptcha

  //   // console.log(`Resolved response token: ${captchaResponse}`);
  //   // console.log("heree   " +captchaResponse);
  //   // console.log(this.recaptcha.value.recaptchaReactive);

  //   this.submittedRecaptcha = true;

  //   if (this.recaptcha.invalid) {
  //     this.flag9 = 0;
  //     // document.getElementById("jdevicemake").style.display = "none";

  //     this.isDisabled = true;
  //     document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
  //     document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
  //     document.getElementById("buttonD1").style.color = "#707070";
  //     return;
  //   }
  //   else {
  //     this.flag9 = 1;
  //     // document.getElementById("jdevicemake").style.display = "block";

  //     this.first();
  //   }
  // }

  clearFile(){
    this.FBssh.reset();
    document.getElementById("jssh").style.display = "none";

     this.isDisabledTick = false;
    this.checked = false;
    this.capOption = null;
    // this.initialCaptcha();
    this.captchaRes = {
      "image": null,
      "options": [null, null, null, null]
    }
    this.flag9 = 0;  //captcha flag

    this.isDisabled = true;
    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";
  }

  initialCaptcha() {

    // this.checked = false;
    this.loading = true;
    this.http.post(environment.captcha, {}
      , {
        withCredentials: true
        // ,responseType: 'text'
      }
      
    ).subscribe(
      data => {
        this.loading = false;
        console.log(data);
        this.captchaRes = data;
      });
    
     
 
  console.log("cookies:",document.cookie);

  }


  

  recaptchaFunct(isChecked, captchaD) { //for normal captcha

    if (!this.isDisabledTick) {
      console.log(isChecked);

      this.initialCaptcha();


      if (isChecked) {
        const dialog_ref = this.dialog.open(captchaD, {
          panelClass: 'customlink-dialog-container',

          disableClose: true,

          restoreFocus: false,
          role: 'dialog',
          autoFocus: false,

        })
      }
      else {
        // this.initialCaptcha();
        this.dialog.closeAll();
        this.flag9 = 0;
        this.capOption = null;
        this.isDisabled = true;
        document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
        document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
        document.getElementById("buttonD1").style.color = "#707070";
      }
    }
  }

  handleChange(option) {
    // console.log(option);
    this.capOption = option;
    this.isDisabledCap = false;
    document.getElementById("capbut").style.backgroundColor = "#224797";
    document.getElementById("capbut").style.borderColor = "#224797";
    document.getElementById("capbut").style.color = "white";
  }

  calculateEntypo(input) {
    var num = Number(input);
    // console.log(num);
    var num1 = Math.floor(num / 100);
    var num2 = num % 100;
    if (num1 > 93) {
      num1 = num1 + 33 + 104;
    } else {
      num1 = num1 + 33;
    }

    if (num2 > 93) {
      num2 = num2 + 33 + 104;
    } else {
      num2 = num2 + 33;
    }
    // console.log("res1: " + num1+ ", res2: "+ num2);
    var res1 = String.fromCharCode(num1);
    var res2 = String.fromCharCode(num2);
    return res1 + '' + res2;
  }

  capSub() {

    this.dialog.closeAll();
    if (!this.capOption) {
      console.log("no");

      this.flag9 = 0;
      // document.getElementById("jdevicemake").style.display = "none";

      this.isDisabled = true;
      document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
      document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
      document.getElementById("buttonD1").style.color = "#707070";
      return;
    }
    else {
      console.log("yes");

      this.flag9 = 1;
      // document.getElementById("jdevicemake").style.display = "block";

      this.isDisabledTick = true;
    }
    this.first();
    this.isDisabledCap = true;
    document.getElementById("capbut").style.backgroundColor = "#D7D7D7";
    document.getElementById("capbut").style.borderColor = "#D7D7D7";
    document.getElementById("capbut").style.color = "#707070";

  }

  gohome() {

    this.router.navigateByUrl('/Introduction');
  }

  onCountryChange(event){
    console.log("here is number " +event.dialCode);
    // localStorage.setItem("tempEvent",event.dialCode)
    this.countryCode = event.dialCode;
  }

  proceed(captchaD2) {
    //console.log("enter");
    // let des = this._sanitizer.sanitize(SecurityContext.HTML, this.FBdesc.value.desc)
    if(this.countryCode == 91){
      this.concatNum = this.FBJioID.value.jioId;
    }
    else if(this.countryCode){
      this.concatNum = "+"+this.countryCode+"-"+this.FBJioID.value.jioId;
    }
    else{
      this.concatNum = this.FBJioID.value.jioId;
    }

    console.log("this.concatNum = "+this.concatNum);

    const formData = new FormData();
    formData.append('content', this._sanitizer.sanitize(SecurityContext.HTML, this.FBdesc.value.desc));
    formData.append('deviceMake', this._sanitizer.sanitize(SecurityContext.HTML, this.FBdevicemake.value.devicemake));
    formData.append('deviceModel', this._sanitizer.sanitize(SecurityContext.HTML, this.FBdevicemodel.value.devicemodel));
    formData.append('deviceOs', this._sanitizer.sanitize(SecurityContext.HTML, this.FBosver.value.osver));
    formData.append('feedbackType', this.FBComType.value.ComType);
    formData.append('name', this._sanitizer.sanitize(SecurityContext.HTML, this.FBFname.value.Fname));
    formData.append('phoneNr', this.concatNum);
    if (this.FBssh.value.ssh) {
      formData.append('attachment', this.actualFile);
    }
    console.log(this.capOption);

    formData.append('captchaInput', this.capOption);

    // formData.append('recaptchaInput', btoa(this.recaptcha.value.recaptchaReactive));  //base64 encode


    // let data = {
    //   "content": this.FBdesc.value.desc,
    //   "deviceMake": this.FBdevicemake.value.devicemake,
    //   "deviceModel": this.FBdevicemodel.value.devicemodel,
    //   "deviceOs": this.FBosver.value.osver,
    //   // "emailId": this.FBemail.value.email,
    //   "name": this.FBFname.value.Fname,
    //   "phoneNumber": this.FBJioID.value.jioId,
    //   "feedbackType": this.FBComType.value.ComType,
    //   "screenshot": this.FBssh.value.ssh
    // }
    // console.log(formData);
    this.http.post(environment.sendFeedback, formData, {
      headers: {
        // 'Content-Type': 'application/json'
      },
      withCredentials: true
    }).subscribe(
      data => {
        // console.log(data);
        // this.feedRes = data;
        // if (this.feedRes.status == "SUCCESS") {
        document.getElementById("firstPart").style.display = "none";
        document.getElementById('errormsg').style.display = 'none';


        document.getElementById("secondPart").style.display = "block";

        this.res = data;
        // }
        // else {
        //   if (this.feedRes.error == "3153") {
        //     this.message = "File extension not supported for attachment. Allowed file extensions are jpg,jpeg,zip,rar,png only"
        //   }
        //   document.getElementById('errormsg').style.display = 'block';
        //   document.getElementById("firstPart").style.display = "block";


        //   document.getElementById("secondPart").style.display = "none";

        // }
      },
      err => {
        console.log(err);
        this.isDisabledTick = false;
        this.checked = false;
        this.capOption = null;
        // this.initialCaptcha();
        this.captchaRes = {
          "image": null,
          "options": [null, null, null, null]
        }

        this.isDisabled = true;
        document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
        document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
        document.getElementById("buttonD1").style.color = "#707070";

        console.log(err.error)
        if (err.error.errorCd == "0153") {
          this.message = "File extension not supported for attachment. Allowed file extensions are jpg,jpeg,png only";
          document.getElementById('errormsg').style.display = 'block';
          document.getElementById("firstPart").style.display = "block";
          document.getElementById("secondPart").style.display = "none";
        }
        else if (err.error.errorCd == "0125") {
          this.message2 = "Incorrect CAPTCHA";
          const dialog_ref = this.dialog.open(captchaD2, {
            panelClass: 'customlink-dialog-container',

            disableClose: true,

            restoreFocus: false,
            role: 'dialog',
            autoFocus: false,

          })
        }
        else {
          this.message = null;
          document.getElementById('errormsg').style.display = 'block';
          document.getElementById("firstPart").style.display = "block";
          document.getElementById("secondPart").style.display = "none";
        }
      })

  }
  refreshpage() {
    location.reload();
  }

  sendphonelink1(successcontent, successlinksent, failurelinksent) {
    this.submitted1 = true;
    if (this.modal1.invalid) {


      document.getElementById("errormessage").style.display = "block";



    }
    else {

      document.getElementById("errormessage").style.display = "none";

      let data = {
        "phoneno": this.modal1.value.jioId,
        "flag": "0"
      }
      //console.log(data);
      this.http.post(environment.sendSms, data).subscribe(
        data => {
          //console.log(data);

          this.res = data;
          if (this.res.status == "SMS Send Successfully") {
            // this.dialog.closeAll()
            this.contenthide = true;


            const dialog_ref = this.dialog.open(successlinksent, {
              panelClass: 'customlink-dialog-container',

              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,


            })
          }
          else {
            // this.dialog.closeAll()
            this.contenthide = true;

            const dialog_ref = this.dialog.open(failurelinksent, {
              panelClass: 'customlink-dialog-container',

              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,

            })

          }

          ;
        }
        ,
        err => {
          this.contenthide = true;

          const dialog_ref = this.dialog.open(failurelinksent, {
            panelClass: 'customlink-dialog-container',

            disableClose: true,

            restoreFocus: false,
            role: 'dialog',
            autoFocus: false,

          })

        })
    }
  };
  sendphonelink2(successcontent, successlinksent, failurelinksent) {
    this.submitted1 = true;
    if (this.modal1.invalid) {


      document.getElementById("errormessage").style.display = "block";



    }
    else {

      document.getElementById("errormessage").style.display = "none";
      let data = {
        "phoneno": this.modal1.value.jioId,
        "flag": "1"
      }
      //console.log(data);
      this.http.post(environment.sendSms, data).subscribe(
        data => {
          //console.log(data);
          this.res = data;
          if (this.res.status == "SMS Send Successfully") {
            // this.dialog.closeAll()
            this.iphonecontenthide = true;

            const dialog_ref = this.dialog.open(successlinksent, {
              panelClass: 'customlink-dialog-container',

              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,

            })


          }
          else {
            // this.dialog.closeAll()
            this.iphonecontenthide = true;

            const dialog_ref = this.dialog.open(failurelinksent, {
              panelClass: 'custom-dialog-container',

              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,

            })

          }

          ;
        }
        ,
        err => {
          this.iphonecontenthide = true;


          const dialog_ref = this.dialog.open(failurelinksent, {
            panelClass: 'customlink-dialog-container',

            disableClose: true,

            restoreFocus: false,
            role: 'dialog',
            autoFocus: false,

          })

        })
    }
  }
  showModal1(successcontent) {

    this.successcontenthide = false;
    this.dialog_2 = this.dialog.open(successcontent, {
      panelClass: 'success-dialog-container',
      restoreFocus: true,
      role: 'dialog',
      autoFocus: false,
      disableClose: true,
      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';

    })

  }
  sendandroidphonelink(content) {
    this.successcontenthide = true;
    this.contenthide = false;
    this.dialog_1 = this.dialog.open(content, {
      panelClass: 'custom-dialog-container',
      autoFocus: false,
      restoreFocus: true,
      role: 'dialog',
      disableClose: true,

      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';

    })


  }
  sendiphonelink(iphonecontent) {
    this.successcontenthide = true;

    this.iphonecontenthide = false;
    this.dialog_1 = this.dialog.open(iphonecontent, {
      panelClass: 'custom-dialog-container',
      autoFocus: false,
      restoreFocus: true,
      role: 'dialog',
      disableClose: true,

      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';

    })

  }

}